import { computed, Signal } from '@angular/core';
import { signalStoreFeature, type, withComputed } from '@ngrx/signals';
import { EntityProps, EntityState } from '@ngrx/signals/entities';
import { SelectedEntityState } from '@shared/store/selected-entity.feature';

import { Étape } from '../../models/étape.model';

export function avecSélecteursÉtapes<_>() {
  return signalStoreFeature(
    {
      state: type<EntityState<Étape> & SelectedEntityState>(),
      props: type<EntityProps<Étape> & { selectedEntity: Signal<Étape | null> }>(),
    },
    withComputed((store) => ({
      pointsDeDepartActifs: computed(() => store.entities().filter((x) => x.estPointDepart && !x.estSupprimee)),
      étapesActives: computed(() => store.entities().filter((x) => !x.estPointDepart && !x.estSupprimee)),
      étapesSupprimées: computed(() => store.entities().filter((x) => !x.estPointDepart && x.estSupprimee)),
    })),
  );
}
